import {
  MenuItemProps,
  useNotificationCount,
  useTranslationLang,
  useTranslationRoute,
  useTranslations,
} from "@harea/component";
import { LanguagesIcon, LayoutDashboardIcon } from "lucide-react";
import { useMemo } from "react";

export const useLeftSideBarMenuGeneral = () => {
  const [TRANSLATION, DASHBOARD] = useTranslations(i18n);
  const { lang } = useTranslationLang();
  const translationRoute = useTranslationRoute();
  const notificationCount = useNotificationCount();

  return useMemo(
    (): MenuItemProps => ({
      className: "menu-item-category",
      items: [
        process.env.REACT_APP_ENV === "development"
          ? {
              label: TRANSLATION,
              link: translationRoute("admin/translation"),
              startIcon: <LanguagesIcon />,
            }
          : undefined,
        {
          label: DASHBOARD,
          link: translationRoute("admin/dashboard"),
          startIcon: <LayoutDashboardIcon />,
        },
      ],
    }),
    [notificationCount, lang],
  );
};

const i18n = [
  "BSMRH.Admin.LeftSideBar.Menu.General.Translation.Label",
  "BSMRH.Admin.LeftSideBar.Menu.General.Dashboard.Label",
];
